import React from 'react';
import { Layout, Dropdown, Avatar, Space, Typography, Divider } from 'antd';
import { UserOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import CompanySwitcher from '../CompanySwitcher';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ collapsed, setCollapsed, isMobile }) => {
  const { user, logout } = useAuth();

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'ออกจากระบบ',
      onClick: logout,
    },
  ];

  return (
    <AntHeader
      style={{
        padding: '0 24px',
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '64px',
      }}
    >
      {/* Left Side - System Title */}
      <Space size="middle" align="center">
        {isMobile && (
          <MenuOutlined
            style={{ fontSize: '20px', cursor: 'pointer', color: '#1890ff', marginRight: '8px' }}
            onClick={() => setCollapsed(!collapsed)}
          />
        )}
        <Text strong style={{ fontSize: isMobile ? '16px' : '18px', color: '#1890ff' }}>
          SecurePlus
        </Text>
      </Space>

      {/* Right Side - User Info and Controls */}
      <Space size="large" align="center">
        {/* Advanced Company Switcher */}
        <CompanySwitcher />

        {/* Current Company Display for regular users */}
        {user?.role !== 'multi_company_admin' && user?.company_name && (
          <Space align="center" style={{ display: isMobile ? 'none' : 'flex' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>บริษัท:</Text>
            <Text strong>{user.company_name}</Text>
          </Space>
        )}

        <Divider type="vertical" style={{ height: '24px' }} />

        {/* User Menu */}
        <Dropdown
          menu={{ items: userMenuItems }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Space style={{ cursor: 'pointer' }} align="center">
            <Avatar size="small" icon={<UserOutlined />} />
            <Space direction="vertical" size={0} style={{ lineHeight: 1, display: isMobile ? 'none' : 'flex' }}>
              <Text strong style={{ fontSize: '13px', lineHeight: '16px' }}>{user?.name}</Text>
              <Text type="secondary" style={{ fontSize: '11px', lineHeight: '14px' }}>
                {user?.role === 'multi_company_admin' ? 'ผู้ดูแลหลายบริษัท' :
                  user?.role === 'multi_company_patrol' ? 'ผู้จัดการ รปภ' :
                    user?.role === 'super_admin' ? 'ผู้ดูแลระบบ (Super Admin)' :
                      user?.role === 'owner' ? 'เจ้าของบริษัท (Owner)' :
                        user?.role === 'supervisor' ? 'หัวหน้างาน (Supervisor)' : user?.role}
              </Text>
            </Space>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;